import Http from '@/utils/http/index';

// 获取联系人列表
export function getContactList(params) {
  return Http.get('/merchant/payee/page', { params });
}

/**
 * 收款人添加
 */
export function postAddPayeeVerify(params) {
  return Http.post('/merchant/payee/add', params);
}

// 验证收款人参数是否正确
export function postValidatePayee(params) {
  return Http.post('/merchant/payee/validatePayee', params);
}

export async function getCountryGroupListByName(params) {
  try {
    const res = await Http.get('/country/listCountryGroupByName', { params });
    return res;
  } catch (err) {
    // 异常处理返回空，防止报错
    return {
      countryGroupInfos: [],
    };
  }
}

/**
 * 收款人总信息
 */
export function getPayeeInfo(params) {
  return Http.get('/merchant/payee/info', { params });
}

/**
 * 下载收款人
 */
export function downloadPayeeList(params) {
  return Http.get('/merchant/payee/download', { params });
}

/**
 * 设为默认
 */
export function postDefaultCard(params) {
  return Http.post('/merchant/payee/defaultAccount', params);
}

/**
 * 收款人修改
 */
export function postUpdatePayeeVerify(params) {
  return Http.post('/merchant/payee/update', params);
}

/**
 * 上传材料
 * @param {*} data
 * @returns
 */
export function uploadMaterial(data) {
  const options = {
    headers: { 'Content-Type': 'multipart/form-data' },
  };
  return Http.post('/payee/upload', data, options);
}

/**
 * 模板资料
 * @param {*} data
 * @returns
 */
export function getMaterialInfoList(data = {}) {
  const params = {
    ...data,
  };
  if (data.payoutCurrency) {
    // 材料模板只区分 CNY 与 外币（ALL）
    params.payoutCurrency = data.payoutCurrency === 'CNY' ? 'CNY' : 'ALL';
  }
  if (data.registration) {
    const registrationArr = ['CN', 'HK', 'CA'];
    params.registration = registrationArr.indexOf(data.registration) > -1 ? data.registration : 'ALL';
  }
  return Http.get('/userMaterialTemplate/getMaterialInfoList', { params });
}

/**
 * 模板资料上传
 */
export function uploadMaterialUseTemplate(file) {
  const param = new FormData(); // 创建form对象
  param.append('file', file);
  return Http.post('/userMaterialTemplate/upload', param, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
}

export function queryBankListByCountry(params) {
  return Http.get('/payee/bankList', { params });
}

export function queryPayoutExchangeConfig(params) {
  return Http.get('/common/getIssueCurrencyByCountry', { params });
}

export function queryWalletTypeByCountry(params) {
  return Http.get('/common/getWalletTypeByCountry', { params });
}

export function queryPickUpBankNameByCountry(params) {
  return Http.get('/common/getWithdrawalInstitution', { params });
}

export function queryPickUpBankBranchName(params) {
  return Http.get('/common/getWithdrawalInstitutionBranch', { params });
}

export function queryPickUpBankBranchInfo(params) {
  return Http.get('/common/getQueryInstitutionBranchList', { params });
}

export function queryWalletType(params) {
  return Http.get('/payoutMer/getWalletDetailList', { params });
}

export async function queryBankInfoBySwiftAndCountry(params) {
  const res = await Http.get('/common/getBankInfoBySwiftAndCountry', { params });
  const list = res.slice(0, 2000).map((item) => ({
    ...item,
    value: item.swiftCode,
    label: `${item.isShow}` === 'false' ? item.bankName : `${item.swiftCode} - ${item.bankName}`,
  }));
  return list;
}

export function queryPayeeFields(params) {
  return Http.get('/merchant/payee/queryPayeeFields', { params });
}
